<script>
    import * as CONST from "../../const";
    import UIVariants from "./variants.svelte";
    import UIPictureModules from "./picture.modules.svelte";
    import UIPictureSize from "./picture.size.svelte";
    import UIFixedPrice from "./fixed.price.svelte";

    import {
        DEFAULT_IMAGE,
        DEFAULT_BACKGROUND,
        DEFAULT_BACKGROUND_LARGE,
        DEFAULT_PREVIEW_TO_BACKGROUND_RATIO,
        PREVIEW_BACKGROUND_HEIGHT,
        PREVIEW_BACKGROUND_HEIGHT_LARGE,
        PREVIEW_BACKGROUND_CHANGE_THRESHOLD,
        ONE_MODULE_PRINT,
    } from "../../const";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let previewToBackgroundRatio = DEFAULT_PREVIEW_TO_BACKGROUND_RATIO;
    export let MODULES = [];
    export let picture = DEFAULT_IMAGE;
    export let pictureDimensionsRate = 50;
    export let pictureDimensionsConstraints;
    export let dimensionWidth = 10;
    export let dimensionHeight = 10;
    export let totalPriceOriginal = 0;
    export let totalPriceWithDiscount = 0;
    export let selectedModule;

    let pictureCache,
        picWidth,
        picHeight,
        previewBackgroundHeight,
        previewBackgroundWidth;

    function onModuleSetVariantClick(ev) {
        selectedModule = MODULES.find(
            (mod) => mod.formatModuleID === ev.detail
        );
        dispatch("moduleChange", selectedModule);
    }

    function cacheIsReady(ev) {
        picHeight = pictureCache.naturalHeight;
        picWidth = pictureCache.naturalWidth;
        //console.log("pic cached", picWidth, picHeight);
        dispatch("pictureCached", pictureCache);
    }

    $: {
        if (picture) {
            pictureCache = new Image();
            pictureCache.onload = cacheIsReady;
            pictureCache.src = picture;
        }
    }

    $: {
        if (!selectedModule && MODULES.length > 0) {
            selectedModule = ONE_MODULE_PRINT;
        }
    }

    let picRatio, previewWidth, previewHeight, innerPicWidth, innerPicHeight;
    let realitySizeFactor = 1;

    $: {
        // px/cm
        realitySizeFactor =
            previewBackgroundHeight /
            (dimensionHeight < PREVIEW_BACKGROUND_CHANGE_THRESHOLD
                ? PREVIEW_BACKGROUND_HEIGHT
                : PREVIEW_BACKGROUND_HEIGHT_LARGE);
        console.log("realitySizeFactor", realitySizeFactor);
        if (
            previewBackgroundWidth &&
            previewBackgroundHeight &&
            picWidth &&
            picHeight
        ) {
            console.log(
                "previewBackground size in px",
                previewBackgroundWidth,
                previewBackgroundHeight
            );
            console.log("pic size", picWidth, picHeight);
            picRatio = picWidth / picHeight;
            console.log("pic ratio", picRatio);

            previewWidth = realitySizeFactor * dimensionWidth; //previewBackgroundWidth * previewToBackgroundRatio;
            previewHeight = realitySizeFactor * dimensionHeight; //previewBackgroundHeight * previewToBackgroundRatio;
            console.log(
                "material size and ratio",
                dimensionWidth,
                dimensionHeight,
                dimensionWidth / dimensionHeight
            );
            //size of preview block in px
            console.log(
                "preview size in px",
                previewWidth,
                previewHeight,
                previewWidth / previewHeight
            );

            if (picRatio > 1.0) {
                innerPicWidth = previewHeight * picRatio;
                innerPicHeight = previewHeight;
                /*  console.log(
                    "pic is horizontal, ",
                    innerPicWidth,
                    innerPicHeight
                );*/
            } else {
                innerPicWidth = previewWidth;
                innerPicHeight = previewWidth / picRatio;
                //console.log("pic is vertical", innerPicWidth, innerPicHeight);
            }
            console.log("inner pic ratio", innerPicWidth / innerPicHeight);
        }
    }

    let backgroundImage;
    $: {
        backgroundImage =
            dimensionHeight < PREVIEW_BACKGROUND_CHANGE_THRESHOLD
                ? DEFAULT_BACKGROUND
                : DEFAULT_BACKGROUND_LARGE;
    }

    let leftShift = 0.5,
        topShift = 0.5;
</script>

<div class="module-calc">
    <div class="module-calc-preview-background-wrapper">
        <div
            bind:offsetHeight={previewBackgroundHeight}
            bind:offsetWidth={previewBackgroundWidth}
            class="module-calc-preview-background"
            style={`background-image: url("${backgroundImage}");`}
        >
            <div
                style={`
            top: ${topShift * previewBackgroundHeight}px;
            left: ${leftShift * previewBackgroundWidth}px;
            width: ${realitySizeFactor * dimensionWidth}px;
            height: ${realitySizeFactor * dimensionHeight}px;
            position: absolute;
            transform: translateX(-50%) translateY(-50%);                  
        `}
            >
                <UIPictureModules
                    picWidth={innerPicWidth}
                    picHeight={innerPicHeight}
                    {picture}
                    value={selectedModule?.value || []}
                />
            </div>
        </div>
    </div>
    <div class="module-calc-form">
        <UIPictureSize
            bind:value={pictureDimensionsRate}
            on:sizeChange
            on:heightChange
            on:widthChange
            bind:width={dimensionWidth}
            bind:height={dimensionHeight}
            constraints={pictureDimensionsConstraints}
        ></UIPictureSize>
        <div class="calc_steps scrollBlock"></div>
        <UIVariants
            variants={MODULES}
            on:click={onModuleSetVariantClick}
            startWith={1}
        />
        <div class="prices-row-bottom">
            <span class="calc_price_original inline_total_price_original"
                >{totalPriceOriginal}</span
            >
            <span class="calc_price inline_total_price"
                >{totalPriceWithDiscount}</span
            >
        </div>
    </div>
    <div class={`.${CONST.CLASS_PREFIX}steps`}></div>
</div>

<div class="module-calc-uploader">
    <div id="files_drop">
        <input
            type="file"
            name="files"
            class={CONST.FILE_UPLOADER_INPUT_CLASS}
            multiple="multiple"
        />
    </div>
</div>
<div class={`${CONST.CLASS_PREFIX}form`}></div>
<UIFixedPrice price={totalPriceWithDiscount} />
